<template>
  <v-hover v-slot:default="{ hover }">
    <v-card :elevation="hover ? 8 : 2" color="blue5" @click="doNavigation">
      <v-card-title style="white-space:pre;" class="subtitle-1 pt-2">
        <span v-if="vehicle.year">{{ vehicle.year }} </span>
        <span v-if="vehicle.make">{{ vehicle.make }}</span>
        <span v-if="vehicle.model"> {{ vehicle.model }}</span>
      </v-card-title>
      <v-card-subtitle class="pb-2">
        <div v-if="vehicle.type === 1 && vehicle.boatName">{{ vehicle.boatName }}</div>
        <div>Total Premium: ${{ vehicle.totalPremium }}</div>
      </v-card-subtitle>
    </v-card>
  </v-hover>
</template>

<style scoped>
</style>

<script>

export default {
  name: 'VehicleSummary',
  props: {
    vehicle: {
      type: Object,
      default: null
    }
  },
  methods: {
    doNavigation () {
      if ((this.vehicle || null) === null) return;
      var newPath = `${this.$route.path}/vehicle/${this.vehicle.id}`;
      this.$router.push(newPath);
    }
  }
};
</script>
